export default __webpack_public_path__ + "static/media/template_weekly.935c804a.png";